// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__6h1oV","header":"Tabs_header__IhpVl","titleContainer":"Tabs_titleContainer__grrtY"};